export default __webpack_public_path__ + "static/SRUS RT198 - Especification Del Producto y Datos Técnicos-02c8dbf00697000816ce5e7b7cec19d4.pdf";